import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allTab", "completedTab", "inProgressTab", "todoTab", "contentArea",
                    "allCount", "completedCount", "inProgressCount", "todoCount"]
  static values = {
    missionId: String,
    placeId: String,
    taskerId: String
  }

  connect() {
    // Set initial active tab (All)
    this.setActiveTab(this.allTabTarget)
  }

  // Mission filter methods
  filterAll(event) {
    event.preventDefault()
    this.setActiveTab(this.allTabTarget)
    this.loadResponses("", "mission")
  }

  filterCompleted(event) {
    event.preventDefault()
    this.setActiveTab(this.completedTabTarget)
    this.loadResponses("ended", "mission")
  }

  filterInProgress(event) {
    event.preventDefault()
    this.setActiveTab(this.inProgressTabTarget)
    this.loadResponses("scheduled,started,stopped", "mission")
  }

  filterTodo(event) {
    event.preventDefault()
    this.setActiveTab(this.todoTabTarget)
    this.loadResponses("todo", "mission")
  }

  // Place filter methods
  filterAllPlace(event) {
    event.preventDefault()
    this.setActiveTab(this.allTabTarget)
    this.loadResponses("", "place")
  }

  filterCompletedPlace(event) {
    event.preventDefault()
    this.setActiveTab(this.completedTabTarget)
    this.loadResponses("ended", "place")
  }

  filterInProgressPlace(event) {
    event.preventDefault()
    this.setActiveTab(this.inProgressTabTarget)
    this.loadResponses("scheduled,started,stopped", "place")
  }

  filterTodoPlace(event) {
    event.preventDefault()
    this.setActiveTab(this.todoTabTarget)
    this.loadResponses("todo", "place")
  }

  // Tasker filter methods
  filterAllTasker(event) {
    event.preventDefault()
    this.setActiveTab(this.allTabTarget)
    this.loadResponses("", "tasker")
  }

  filterCompletedTasker(event) {
    event.preventDefault()
    this.setActiveTab(this.completedTabTarget)
    this.loadResponses("ended", "tasker")
  }

  filterInProgressTasker(event) {
    event.preventDefault()
    this.setActiveTab(this.inProgressTabTarget)
    this.loadResponses("scheduled,started,stopped", "tasker")
  }

  filterTodoTasker(event) {
    event.preventDefault()
    this.setActiveTab(this.todoTabTarget)
    this.loadResponses("todo", "tasker")
  }

  setActiveTab(activeTab) {
    // Remove active classes from all tabs
    [this.allTabTarget, this.completedTabTarget, this.inProgressTabTarget, this.todoTabTarget].forEach(tab => {
      tab.classList.remove("border-blue-500", "text-blue-600")
      tab.classList.add("border-transparent", "text-gray-500")
    })

    // Add active classes to clicked tab
    activeTab.classList.remove("border-transparent", "text-gray-500")
    activeTab.classList.add("border-blue-500", "text-blue-600")
  }

  loadResponses(statusFilter, resourceType) {
    const frame = this.contentAreaTarget.querySelector("turbo-frame")
    if (!frame) return

    // Get current URL params from frame's src or build base URL
    let baseUrl, parentPath
    if (resourceType === "mission") {
      baseUrl = `/missions/${this.missionIdValue}/responses`
      parentPath = `/missions/${this.missionIdValue}`
    } else if (resourceType === "place") {
      baseUrl = `/places/${this.placeIdValue}/responses`
      parentPath = `/places/${this.placeIdValue}`
    } else if (resourceType === "tasker") {
      baseUrl = `/users/${this.taskerIdValue}/responses`
      parentPath = `/users/${this.taskerIdValue}`
    }

    // Parse existing URL params from current frame src if available
    const currentUrl = new URL(frame.src || window.location.href)
    const params = new URLSearchParams(currentUrl.search)

    // Always set format to turbo_stream for the frame
    params.set('format', 'turbo_stream')

    // Remove any existing status filters
    params.delete('q[status_eq]')
    params.delete('q[status_in][]')

    // Add new status filter if provided
    if (statusFilter === "") {
      // All - no filter needed
    } else if (statusFilter === "scheduled,started,stopped") {
      // In Progress - multiple statuses
      statusFilter.split(',').forEach(status => {
        params.append('q[status_in][]', status)
      })
    } else {
      // Single status
      params.set('q[status_eq]', statusFilter)
    }

    // Build final URL with all params for the turbo frame
    const url = `${baseUrl}?${params.toString()}`

    frame.src = url
    frame.reload()

    // Update browser URL (without format parameter)
    const browserParams = new URLSearchParams(params)
    browserParams.delete('format')

    const browserUrl = browserParams.toString()
      ? `${parentPath}?${browserParams.toString()}`
      : parentPath

    window.history.pushState({}, '', browserUrl)
  }
}
